const state = {
  dictionTitle: '',
  look: '',
  dictForm: {
    name: '',
    dict_id: null,
    context: ''
  },
  dictChildren: [],
  dict_id: null,
};

const mutations = {
  setTitle(state, payload) {
    state.dictionTitle = payload.title;
    state.look = payload.look;
  },
  setRowData(state, payload) {
    state.dictForm = payload.form;
    state.dictChildren = payload.children;
    state.dict_id = payload.form.dict_id
  }
};

const actions = {

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
